/* /crm/website: het websitescherm (ADR 0034). De planning (taken, tekstconcepten, notities, ideeën)
 * staat op /crm/website/planning; de content van de site zelf onder /crm/website/site. */
import { WebsiteOverzichtScherm } from '@/features/website/Overzicht';

export default function CRMWebsiteOverzicht() {
  return <WebsiteOverzichtScherm />;
}
